module.exports = __webpack_public_path__ + "static/image1-f2b7a94f661ad9d8951e96538def7ceb.png";